import React from 'react';

import boxIcon from 'assets/svg/icons/box.svg';
import { EmailLink } from 'components/Button/Button.styled';
import {
	EMPTY_BIOMARKER_LINK,
	EMPTY_BIOMARKER_MESSAGE,
	IMAGE_ALT_TEXT,
} from 'utils/internationalization/en';

import * as Styled from './Biomarkers.styled';

const BiomarkerEmptyStateCard = ({ image }: { image: string }) => {
	return (
		<Styled.EmtyStateContainer className='empty-state-card'>
			<Styled.ImgWrapper>
				<img src={image || boxIcon} alt={IMAGE_ALT_TEXT} />
			</Styled.ImgWrapper>

			<Styled.TextWrapper>
				<Styled.Text>
					{EMPTY_BIOMARKER_MESSAGE}
					<EmailLink href={'mailto:help@cenegenics.com'}>
						{EMPTY_BIOMARKER_LINK}
					</EmailLink>
				</Styled.Text>
			</Styled.TextWrapper>
		</Styled.EmtyStateContainer>
	);
};

export default BiomarkerEmptyStateCard;
